import React from 'react'
import classnames from 'classnames'

import { Food, getFoodTranslation } from '../../../core/foods'
import { LANGUAGE_CODES, SupportedLanguageCode } from '../../../core/i18n'
import styles from '../../styles/modules/table.module.scss'

interface Props {
  food: Food
  activeLanguage: SupportedLanguageCode
}

const FoodInfoTable: React.FC<Props> = props => {
  const { food, activeLanguage } = props

  return (
    <div
      className={classnames({
        [styles.wrapper]: true,
        [styles.stocker]: true,
      })}
    >
      <table className={`${styles.container} ${styles.foodInfoTable}`}>
        <tbody>
          <tr className={styles.inputRowStatic}>
            <td className={styles.inputCell}>フード名</td>
            <td className={styles.inputCell}>
              {activeLanguage === LANGUAGE_CODES.JAPANESE
                ? props.food.name || ''
                : getFoodTranslation(
                    props.food.foodTranslations,
                    LANGUAGE_CODES.ENGLISH
                  )?.name || ''}
            </td>
          </tr>
          <tr className={styles.inputRowStatic}>
            <td className={styles.inputCell}>価格(税込)</td>
            <td className={styles.inputCell}>
              {food.price ? `${food.price}円` : '未設定'}
            </td>
          </tr>
          <tr className={styles.inputRowStatic}>
            <td className={styles.inputCell}>価格(税抜)</td>
            <td className={styles.inputCell}>
              {food.priceExcludingTax ? `${food.priceExcludingTax}円` : '未設定'}
            </td>
          </tr>
          <tr className={styles.inputRowStatic}>
            <td className={styles.inputCell}>カテゴリ</td>
            <td className={styles.inputCell}>
              {food.categoryDisplayName || '未設定'}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default FoodInfoTable
